import React from 'react';
import { ArrowLeft, ArrowRight } from '@mui/icons-material';

export default function CategoryDeck({ categoryList, category, onMoveStatus }) {
  return (
    <div className="card">
      <div className="card-body">
        <h2 className="card-title mt-0">{category}</h2>
        {categoryList.map((item, idx) => (
          <div className="d-flex flex-row justify-content-between align-items-center" key={idx}>
            {category !== 'New' ? (
              <ArrowLeft onClick={() => onMoveStatus(item, category, 'left')} />
            ) : null}
            <div className="my-2">{item.name}</div>
            {category !== 'Unsuccessful' ? (
              <ArrowRight onClick={() => onMoveStatus(item, category, 'right')} />
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
}
